let mergeOptions = require('videojs/es5/utils/merge-options.js').default;

export default <any>mergeOptions;


// WEBPACK FOOTER //
// ./src/app/utils/wrappers/merge-options.ts